function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 30px 0 35px;\n\n  svg {\n    vertical-align: middle;\n    padding-bottom: 3px;\n    margin-right: 5px;\n  }\n\n  a {\n    font-style: italic;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 15px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 30px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  .dropdown-trigger {\n    text-align: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 20px;\n  text-align: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  float: right;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
import React, { PureComponent, Fragment } from "react";
import propTypes from "prop-types";
import memoizeOne from "memoize-one";
import { debounce, orderBy } from "lodash";
import { context, withContext } from "../wr-context";
import { requests, utils } from "../../modules/proposals";
import { requests as productRequests } from "../../modules/product";
import { FaEllipsisV, FaArrowLeft, FaRegFilePdf, FaRegFileWord } from "react-icons/fa";
import { TiArrowSortedDown } from "react-icons/ti";
import connectRequest from "../../utils/connect-request";
import Progress from "../progress";
import { MutedText, MediumText, EngravedText, CenteredText } from "../text";
import { Grid } from "../grid";
import Table from "../table";
import Dropdown from "../dropdown";
import Link from "../link";
import formatCurrency from "../../utils/format-currency";
import compose from "../../utils/compose";
import formatDate from "../../utils/format-date";
import Button from "../button";
import { buildConfirmationModal } from "../modal/builders";
import styled from "styled-components";
import { FiPaperclip } from "react-icons/fi";
import i18n from "../../utils/i18n";
import { PromiseState } from "react-refetch";
import Pagination from "../pagination";
import SearchBox from "../SearchBox";
var BackToCatalog = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.backButton) === null || ref === void 0 ? void 0 : ref.container;
});
var SmallSpacer = styled.div(_templateObject1());
var Spacer = styled.div(_templateObject2());
var StyledFiPaperclip = styled(FiPaperclip)(_templateObject3());
var ConfirmationText = styled.div(_templateObject4());
var DropdownContainer = styled.div(_templateObject5());
var ModalDescription = styled.p(_templateObject6());
var PaginationWrapper = styled.div(_templateObject7());
var getTextFilter = function() {
    return ProductList.filterText ? {
        phraseFilter: ProductList.filterText,
        phraseFilterFields: [
            "settings.clientName"
        ]
    } : {};
};
var ProductList = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ProductList, PureComponent);
    var _super = _createSuper(ProductList);
    function ProductList() {
        _classCallCheck(this, ProductList);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            inputFilterText: ""
        };
        _this.ProposalName = function(param) {
            var row = param.row;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", null, row.name), row.quote && /*#__PURE__*/ React.createElement(Link, {
                href: row.quote
            }, /*#__PURE__*/ React.createElement(StyledFiPaperclip, null)));
        };
        _this.Actions = function(param) {
            var row = param.row;
            return /*#__PURE__*/ React.createElement(Dropdown, null, function(param) {
                var DropdownTrigger = param.DropdownTrigger, DropdownList = param.DropdownList;
                return /*#__PURE__*/ React.createElement(DropdownContainer, null, /*#__PURE__*/ React.createElement(DropdownTrigger, null, /*#__PURE__*/ React.createElement(Link, null, /*#__PURE__*/ React.createElement(FaEllipsisV, null))), /*#__PURE__*/ React.createElement(DropdownList, null, /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Button, {
                    onClick: function() {
                        return _this.handleDelete(row.id);
                    },
                    primary: false,
                    fullWidth: true
                }, i18n("proposals.actions.delete"))))));
            });
        };
        _this.Status = function(param) {
            var row = param.row;
            var _props = _this.props, showStatusChange = _props.showStatusChange, asQuotePdf = _props.asQuotePdf, asQuoteWord = _props.asQuoteWord;
            if (!showStatusChange || !asQuotePdf && !asQuoteWord) {
                return /*#__PURE__*/ React.createElement(React.Fragment, null, row.status);
            } else {
                return /*#__PURE__*/ React.createElement(Dropdown, null, function(param) {
                    var DropdownTrigger = param.DropdownTrigger, DropdownList = param.DropdownList;
                    return /*#__PURE__*/ React.createElement(DropdownContainer, null, /*#__PURE__*/ React.createElement(DropdownTrigger, null, /*#__PURE__*/ React.createElement(Link, null, row.status, " ", /*#__PURE__*/ React.createElement(TiArrowSortedDown, null))), /*#__PURE__*/ React.createElement(DropdownList, null, /*#__PURE__*/ React.createElement("ul", null, asQuoteWord && /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Button, {
                        onClick: function() {
                            return _this.handleStatusChange("asWord", row);
                        },
                        primary: false,
                        fullWidth: true
                    }, i18n("proposals.status.asQuoteWord"), /*#__PURE__*/ React.createElement(FaRegFileWord, {
                        size: 20
                    }))), asQuotePdf && /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Button, {
                        onClick: function() {
                            return _this.handleStatusChange("asPdf", row);
                        },
                        primary: false,
                        fullWidth: true
                    }, i18n("proposals.status.asQuotePdf"), /*#__PURE__*/ React.createElement(FaRegFilePdf, {
                        size: 20
                    }))))));
                });
            }
        };
        _this.handleDownload = function(proposal) {
            _this.props.downloadProposal(proposal);
        };
        _this.handleDelete = function(id) {
            _this.props.context.actions.openModal(buildConfirmationModal({
                body: /*#__PURE__*/ React.createElement(ConfirmationText, null, i18n("proposals.removeProposalsConfirmation")),
                onConfirm: function() {
                    _this.props.deleteProposal(id);
                }
            }));
        };
        _this.addItemsToCart = function(proposal) {
            var context = _this.props.context;
            var items = proposal.settings.items;
            context.state.catalogs.forEach(function(catalog) {
                var ref, ref1;
                (ref = catalog.contents) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(item) {
                    items.forEach(function(it) {
                        if (it === item.id) {
                            context.actions.addProductToCart(item);
                        }
                    });
                });
            });
        };
        _this.handleStatusChange = function(status, proposal) {
            var _props = _this.props, context = _props.context, submitProposal = _props.submitProposal;
            var _settings = proposal.settings, clientName = _settings.clientName, email = _settings.email, companyName = _settings.companyName, expiryDate = _settings.expiryDate;
            context.actions.resetCarts();
            _this.addItemsToCart(proposal);
            submitProposal === null || submitProposal === void 0 ? void 0 : submitProposal({
                id: proposal.id,
                asDraft: false,
                asQuotePdf: status === "asPdf",
                asQuoteWord: status === "asWord",
                formValues: {
                    company: companyName || "",
                    name: clientName || "",
                    email: email || "",
                    desiredStartDate: expiryDate || ""
                }
            });
            _this.props.context.actions.openModal(_objectSpread({}, _this.modalProps));
        };
        _this.modalProps = {
            showClose: false,
            body: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ModalDescription, null, "We are changing you proposal status"), /*#__PURE__*/ React.createElement(Progress, null))
        };
        _this.columns = [
            {
                id: "name",
                label: i18n("proposals.columns.name"),
                component: _this.ProposalName
            },
            {
                id: "settings.clientName",
                label: i18n("proposals.columns.clientName")
            },
            {
                id: "createdAt",
                label: i18n("proposals.columns.created"),
                formatter: formatDate(),
                isSortable: true
            },
            {
                id: "settings.value",
                label: i18n("proposals.columns.value"),
                formatter: compose(function(n) {
                    return n / 100;
                }, formatCurrency),
                isSortable: true
            },
            {
                id: "status",
                label: i18n("proposals.columns.status"),
                component: _this.Status,
                isSortable: true
            },
            {
                id: "settings.expiryDate",
                label: i18n("proposals.columns.expiration"),
                formatter: formatDate()
            },
            {
                id: "actions",
                label: i18n("proposals.columns.actions"),
                component: _this.Actions
            }, 
        ];
        _this.getColumns = function() {
            var ref, ref1;
            var override = _this.props.getColumns || (context === null || context === void 0 ? void 0 : (ref = context.utils) === null || ref === void 0 ? void 0 : (ref1 = ref.proposals) === null || ref1 === void 0 ? void 0 : ref1.getColumns) || function(c) {
                return c;
            };
            return override(_this.columns);
        };
        _this.renderBackToCatalog = function() {
            return /*#__PURE__*/ React.createElement(BackToCatalog, null, /*#__PURE__*/ React.createElement(Link, {
                to: _this.props.context.getRoutePath("index")
            }, /*#__PURE__*/ React.createElement(FaArrowLeft, null), "Catalog"));
        };
        _this.updateProposals = memoizeOne(function(proposals) {
            proposals = proposals.map(function(proposal) {
                var items = proposal.settings.items;
                var editableProposal = utils.proposalsItemsAvailable(items);
                proposal.editable = Boolean(editableProposal);
                return proposal;
            });
            return proposals;
        });
        _this.refetchProposals = function() {
            _this.props.lazyProposalsFetch({
                limit: 10,
                offset: (ProductList.currentPage - 1) * 10
            });
        };
        _this.handlePageChange = function(page) {
            ProductList.currentPage = page;
            _this.refetchProposals();
        };
        _this.handleSort = function(sortField, sortOrder) {
            ProductList.sortOptions = {
                sortField: sortField,
                sortOrder: sortOrder
            };
            _this.refetchProposals();
        };
        _this.debouncedSearchFetch = debounce(function() {
            ProductList.currentPage = 1;
            _this.refetchProposals();
        }, 500);
        _this.handleChangeFilterText = function(e) {
            var newInput = e.target.value;
            ProductList.filterText = newInput;
            _this.setState({
                inputFilterText: newInput
            });
            _this.debouncedSearchFetch();
        };
        _this.renderList = function() {
            var _props = _this.props, proposalsFetch = _props.proposalsFetch, withPreviousPageOption = _props.withPreviousPageOption, context = _props.context, editAllProposals = _props.editAllProposals, sortProposals = _props.sortProposals, isSortable = _props.isSortable, paginated = _props.paginated;
            var proposals = context.state.proposals;
            var productsFetch = PromiseState.all(context.constants.client.catalogIds.map(function(_, index) {
                return "productsFetch".concat(index);
            })// As any is required if we want to have any props autocomplete on this component
            .map(function(id) {
                return _this.props[id];
            }));
            if (proposalsFetch.pending) {
                return /*#__PURE__*/ React.createElement(Progress, null);
            } else if (proposalsFetch.rejected) {
                return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, withPreviousPageOption && /*#__PURE__*/ React.createElement(React.Fragment, null, _this.renderBackToCatalog()), /*#__PURE__*/ React.createElement(MutedText, {
                    "data-testid": "proposals-error-message"
                }, i18n("proposals.loadingError"))))));
            } else if (!proposals || !proposals.length) {
                return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, withPreviousPageOption && /*#__PURE__*/ React.createElement(React.Fragment, null, _this.renderBackToCatalog()), /*#__PURE__*/ React.createElement(MutedText, {
                    "data-testid": "proposals-error-message"
                }, i18n("proposals.noProposalsError"))))));
            }
            var proposalsToRender = proposals.filter(function(proposal) {
                return proposal.companyId === context.constants.client.companyId;
            });
            if (!paginated) {
                proposalsToRender = orderBy(proposalsToRender, [
                    "createdAt"
                ], [
                    "desc"
                ]);
            }
            if (!editAllProposals && !productsFetch.pending) {
                proposalsToRender = _this.updateProposals(proposalsToRender);
            }
            if (sortProposals) {
                proposalsToRender = sortProposals(proposalsToRender);
            }
            return /*#__PURE__*/ React.createElement(Table, {
                keyField: "id",
                isSortable: isSortable,
                sortColumn: ProductList.sortOptions.sortField,
                sortOrder: ProductList.sortOptions.sortOrder,
                onSort: _this.handleSort,
                columns: _this.getColumns(),
                noDataMessage: i18n("proposals.noProposalsMessage"),
                data: proposalsToRender
            });
        };
        return _this;
    }
    var _proto = ProductList.prototype;
    _proto.render = function render() {
        var _props = this.props, proposalsFetch = _props.proposalsFetch, withPreviousPageOption = _props.withPreviousPageOption, paginated = _props.paginated, searchbox = _props.searchbox;
        var proposalPages = proposalsFetch.meta.count;
        if (searchbox) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, withPreviousPageOption && /*#__PURE__*/ React.createElement(React.Fragment, null, this.renderBackToCatalog()), /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(SearchBox, {
                onChange: this.handleChangeFilterText,
                value: this.state.inputFilterText,
                placeholder: "Search by client name",
                showIcon: true
            }), /*#__PURE__*/ React.createElement(SmallSpacer, null)), this.renderList(), /*#__PURE__*/ React.createElement(SmallSpacer, null), paginated && /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(PaginationWrapper, null, /*#__PURE__*/ React.createElement(Pagination, {
                lastPage: Math.ceil(proposalPages / 10),
                onPageChange: this.handlePageChange,
                loading: proposalsFetch.pending,
                withNavigationArrows: true
            })), /*#__PURE__*/ React.createElement(SmallSpacer, null)));
        } else {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, withPreviousPageOption && /*#__PURE__*/ React.createElement(React.Fragment, null, this.renderBackToCatalog()), paginated && /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(Pagination, {
                lastPage: Math.ceil(proposalPages / 10),
                onPageChange: this.handlePageChange,
                loading: proposalsFetch.pending,
                withNavigationArrows: true
            }), /*#__PURE__*/ React.createElement(Spacer, null)), this.renderList());
        }
    };
    return ProductList;
}(PureComponent);
ProductList.propTypes = {
    paginated: propTypes.bool,
    withPreviousPageOption: propTypes.bool,
    editAllProposals: propTypes.bool,
    asQuoteWord: propTypes.bool,
    asQuotePdf: propTypes.bool,
    showStatusChange: propTypes.bool,
    downloadProposal: propTypes.func,
    context: propTypes.object.isRequired,
    deleteProposal: propTypes.func.isRequired,
    submitProposal: propTypes.func,
    proposalsFetch: propTypes.object.isRequired,
    sortProposals: propTypes.func,
    lazyProposalsFetch: propTypes.func.isRequired,
    getColumns: propTypes.func,
    isSortable: propTypes.bool,
    searchbox: propTypes.bool
};
ProductList.defaultProps = {
    withPreviousPageOption: true,
    editAllProposals: false,
    asQuoteWord: false,
    asQuotePdf: false,
    showStatusChange: true,
    paginated: false,
    downloadProposal: function() {},
    isSortable: false
};
ProductList.currentPage = 1;
ProductList.filterText = "";
ProductList.sortOptions = {
    sortField: "createdAt",
    sortOrder: "desc"
};
export default connectRequest(function(props) {
    var editAllProposals = props.editAllProposals, _searchByCompanyId = props.searchByCompanyId, searchByCompanyId = _searchByCompanyId === void 0 ? false : _searchByCompanyId, paginated = props.paginated, _requestOptions = props.requestOptions, requestOptions = _requestOptions === void 0 ? {} : _requestOptions;
    var queuedRequests = {
        proposalsFetch: requests.fetchProposals(_objectSpread({
            searchByCompanyId: searchByCompanyId
        }, getTextFilter(), paginated ? _objectSpread({
            limit: 10,
            offset: (ProductList.currentPage - 1) * 10
        }, ProductList.sortOptions, requestOptions) : {})),
        deleteProposal: function(id) {
            return requests.deleteProposal(id);
        },
        downloadProposal: function(proposal) {
            return requests.downloadProposal(proposal);
        }
    };
    if (!editAllProposals) {
        context.constants.client.catalogIds.forEach(function(catalogId, index) {
            queuedRequests["productsFetch".concat(index)] = productRequests.fetchProductsByCatalogId(catalogId);
        });
    }
    return _objectSpreadProps(_objectSpread({}, queuedRequests), {
        lazyProposalsFetch: function(param) {
            var limit = param.limit, offset = param.offset;
            return {
                proposalsFetch: requests.fetchProposals(_objectSpread({
                    limit: limit,
                    offset: offset,
                    searchByCompanyId: searchByCompanyId
                }, getTextFilter(), ProductList.sortOptions, requestOptions))
            };
        }
    });
})(withContext(ProductList));
